import {Controller} from "stimulus"

export default class extends Controller {
  static targets = ["stripeUX", "offlineUX", "paymentForm", "paymentMethod"]

  connect() {
    setTimeout(() => {
      const initial = $(this.paymentMethodTarget).find('input:checked').attr('data-payment-method')
      this.paymentMethodSelection = initial
    }, 1)
  }

  reportValidity(event) {
    if (!this.paymentFormTarget.reportValidity()) {
      event.preventDefault()
      event.stopPropagation()
    }
  }

  get paymentMethodSelection() {
    return this.data.get('selectedPaymentMethod')
  }

  set paymentMethodSelection(paymentMethodSelection) {
    this.data.set('selectedPaymentMethod', paymentMethodSelection)

    if (paymentMethodSelection == 'credit_card' || paymentMethodSelection == 'ach') {
      $(this.stripeUXTarget).show()
      $(this.offlineUXTarget).hide()
    } else if (paymentMethodSelection == 'offline') {
      $(this.stripeUXTarget).hide()
      $(this.offlineUXTarget).show()
    }

    this.dispatchStripeRailEvent(paymentMethodSelection)
  }

  selectPaymentMethod(event) {
    let paymentMethodSelection = event.target.getAttribute('data-payment-method');
    this.paymentMethodSelection = paymentMethodSelection
  }

  /** Let the payment modal pre-build Stripe Elements as soon as Card/ACH is chosen. */
  dispatchStripeRailEvent(paymentMethodSelection) {
    let rail = null
    if (paymentMethodSelection === 'credit_card' || paymentMethodSelection === 'ach') {
      rail = paymentMethodSelection === 'ach' ? 'us_bank_account' : 'card'
    }
    document.dispatchEvent(
      new CustomEvent('accounts:stripe-payment-rail', {
        bubbles: true,
        detail:    { rail },
      }),
    )
  }
}
